import { render } from "./InformacoesView.vue?vue&type=template&id=7aa05b1c&scoped=true"
import script from "./InformacoesView.vue?vue&type=script&lang=js"
export * from "./InformacoesView.vue?vue&type=script&lang=js"

import "./InformacoesView.vue?vue&type=style&index=0&id=7aa05b1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aa05b1c"]])

export default __exports__